// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as UserList from "./UserList.bs.js";
import * as UserSelection from "./UserSelection.bs.js";
import * as UserProfileType from "../../../app/entity/UserProfileType.bs.js";
import * as SendSMSAssetsManager from "../../assets/SendSMSAssetsManager.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

SendSMSAssetsManager.importCss(undefined);

function SMSUserSection(Props) {
  var customerAndPartnerDetails = Props.customerAndPartnerDetails;
  var userTypeSelection = Props.userTypeSelection;
  var dispatchUserTypeSelection = Props.dispatchUserTypeSelection;
  var selectUser = Props.selectUser;
  var userCardClick = Props.userCardClick;
  var dispatchUserSelected = Props.dispatchUserSelected;
  var setShowSidePanel = Props.setShowSidePanel;
  if (typeof customerAndPartnerDetails === "number") {
    return React.createElement(CircularLoader$Catalyst.make, {});
  }
  switch (customerAndPartnerDetails.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var data = customerAndPartnerDetails._0;
        var filterCustomerAndPartnerDetails;
        switch (userTypeSelection) {
          case /* All */0 :
              filterCustomerAndPartnerDetails = data;
              break;
          case /* Customer */1 :
              filterCustomerAndPartnerDetails = List.filter(function (user) {
                      var match = UserProfileType.fromString(user.profile);
                      if (match !== 1) {
                        return match < 4;
                      } else {
                        return false;
                      }
                    })(data);
              break;
          case /* Partner */2 :
              filterCustomerAndPartnerDetails = List.filter(function (user) {
                      var match = UserProfileType.fromString(user.profile);
                      return match === 1;
                    })(data);
              break;
          
        }
        return React.createElement("div", {
                    className: "c-user-selection"
                  }, React.createElement(UserSelection.make, {
                        customer_partner_details: data,
                        userTypeSelection: userTypeSelection,
                        dispatchUserTypeSelection: dispatchUserTypeSelection
                      }), React.createElement(UserList.make, {
                        customerAndPartnerDetails: filterCustomerAndPartnerDetails,
                        selectUser: selectUser,
                        userCardClick: userCardClick,
                        dispatchUserSelected: dispatchUserSelected,
                        setShowSidePanel: setShowSidePanel
                      }));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: customerAndPartnerDetails._0
                  });
    
  }
}

var make = SMSUserSection;

export {
  make ,
  
}
/*  Not a pure module */
